import { CircleCheck, Info, Loader2, OctagonX, TriangleAlert } from "lucide-react";
import type { CSSProperties } from "react";
import { Toaster as Sonner } from "sonner";

const icons = {
  success: <CircleCheck className="text-success" size={16} />,
  info: <Info className="text-info" size={16} />,
  warning: <TriangleAlert className="text-warning" size={16} />,
  error: <OctagonX className="text-destructive" size={16} />,
  loading: <Loader2 className="animate-spin" size={16} />
};

const style = {
  "--normal-bg": "var(--seedtime-bg-surface)",
  "--normal-text": "var(--seedtime-text-primary)",
  "--normal-border": "var(--seedtime-border-default)",
  "--border-radius": "var(--seedtime-radius-large)",
  fontFamily: "inherit"
} as CSSProperties;

const toastOptions = {
  style: {
    fontSize: "var(--seedtime-text-body-small)",
    lineHeight: "var(--seedtime-text-body-small--line-height)"
  }
};

const Toaster = () => (
  <Sonner
    data-slot="toaster"
    duration={3000}
    icons={icons}
    mobileOffset={{ top: "calc(16px + env(safe-area-inset-top))" }}
    offset={{ top: "calc(24px + env(safe-area-inset-top))" }}
    position="top-center"
    style={style}
    toastOptions={toastOptions}
  />
);

export { Toaster };
